// System Assets Manager - Server-backed storage
import axios from 'axios';
import { API_BASE_URL } from '../config/api';

let systemAssets = {
  risingLogo: 'https://srv874-files.hstgr.io/03aa42002cf380cb/files/public_html/wp-content/uploads/Rising360.png',
  parentImage: 'https://srv874-files.hstgr.io/03aa42002cf380cb/files/public_html/wp-content/uploads/parent.png'
};

export const getSystemAssets = () => systemAssets;

export const updateSystemAssets = async (newAssets) => {
  systemAssets = { ...systemAssets, ...newAssets };
  
  // Save to both localStorage (immediate) and server (persistent)
  localStorage.setItem('systemAssets', JSON.stringify(systemAssets));
  
  try {
    // Save to server for cross-device access
    await axios.post(`${API_BASE_URL}/api/system-assets`, systemAssets);
  } catch (error) {
    console.warn('Failed to save system assets to server:', error);
  }
};

// Load from server first, fallback to localStorage
const loadSystemAssets = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/api/system-assets`);
    if (response.data) {
      systemAssets = { ...systemAssets, ...response.data };
      localStorage.setItem('systemAssets', JSON.stringify(systemAssets));
    }
  } catch (error) {
    // Fallback to localStorage
    const savedAssets = localStorage.getItem('systemAssets');
    if (savedAssets) {
      try {
        systemAssets = { ...systemAssets, ...JSON.parse(savedAssets) };
      } catch (e) {
        console.warn('Failed to load saved system assets');
      }
    }
  }
};

// Initialize on app start
loadSystemAssets();